import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountingInvoicesXEmployeeReport } from "src/models/Accounting/AccountingReports.models";

interface AccountingInvoicesXEmployeeReportState {
    invoicesXEmployeeReports: IAccountingInvoicesXEmployeeReport[];
}

const initialState: AccountingInvoicesXEmployeeReportState = {
    invoicesXEmployeeReports: [],
};

const AccountingInvoicesXEmployeeReportSlice = createSlice({
    name: "AccountingInvoicesXEmployeeReport",
    initialState,
    reducers: {
        setAccountingInvoicesXEmployeeReportList: (
            state,
            action: PayloadAction<IAccountingInvoicesXEmployeeReport[]>
        ) => {
            state.invoicesXEmployeeReports = action.payload;
        },
        concatListAccountingInvoicesXEmployeeReport: (
            state: AccountingInvoicesXEmployeeReportState,
            action: PayloadAction<IAccountingInvoicesXEmployeeReport[]>
        ) => {
            state.invoicesXEmployeeReports = [...state.invoicesXEmployeeReports.concat(action.payload)];
        },
    },
});

export const {
    setAccountingInvoicesXEmployeeReportList,
    concatListAccountingInvoicesXEmployeeReport
} = AccountingInvoicesXEmployeeReportSlice.actions;

export default AccountingInvoicesXEmployeeReportSlice.reducer;